export const LOADING_STORIES: string = 'assets/loading_text.json';
export const LOADING_GEM_WEEKS: string = 'assets/gems_airdrop/sonic_gem_week_';
